import React from "react"
import { useSelector } from "react-redux"
import { selectContractHistory } from "../../redux/contract/selectors"
import { CaseStates } from "../../Constantes/CaseStates"
import { CaseStateSummaryItem } from "./CaseStateSummaryItem"


function CaseStateSummary(){

    const contractCaseHistory = useSelector(selectContractHistory)
    const byState = contractCaseHistory ? Object.groupBy(contractCaseHistory, ({ stateId }) => stateId) : {};
    const closedStates = new Set([CaseStates.CLOSED.toString(), CaseStates.NOT_MANAGED.toString()])
    const activeStates = Object.entries(byState).filter(state =>!closedStates.has(state[0]))

    return(
        <div style={{backgroundColor: "#fff", height: "8rem", display: "flex", justifyContent: "center", alignItems: "center", columnGap: "2rem"}}>
          {activeStates.map((state)=><CaseStateSummaryItem key={`stateId-${state[0]}`} stateId={state[0]} stateName={state[1][0].state} count={state[1].length}/>)}
        </div>
    )
}

export {CaseStateSummary}